// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kjC3","colMin":"styles_colMin__227N_"};